<template>
  <div class="PricePublic mb-24">
    <div v-if="areaPrice" class="type-headline-lg">
      {{ useLocalizedCurrency(areaPrice) }}<span v-if="taxLabel" class="pl-6">{{ taxLabel }}</span>/{{ unitDisplay }}
    </div>
    <div v-else class="type-headline-lg">
      {{ displayIncVat ? activeVariant.priceInfo.priceDisplay : activeVariant.priceInfo.priceBeforeVatDisplay }}<span v-if="taxLabel" class="pl-6">{{ taxLabel }}</span>
    </div>
    <div class="mt-4 text-text-subtle type-sm">
      {{ displayIncVat ? $t('price.incVat.shown') : $t('price.exVat.shown') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductModel } from '#models/product';
import type { ProductVariantModel } from '#models/productVariant';
import usePackageAreaConverter from '~/composables/usePackageAreaConverter';
import { useGlobalContentStore } from '~/store/globalContent';
import { useLocalizedCurrency } from '~/composables/useLocalizedCurrency';
const globalContent = useGlobalContentStore();

const props = defineProps<{
  productItem: ProductModel,
  activeVariant: ProductVariantModel,
  displayIncVat?: boolean,
}>();

const displayIncVat = computed(() => props.displayIncVat ?? globalContent.getDisplayIncVat);

const { unitDisplay, shouldUseArea, convertPackagePriceToAreaPrice } = usePackageAreaConverter(toRef(()=>props.activeVariant));

const areaPrice = computed(()=> {
  if (shouldUseArea.value) {
    return displayIncVat.value ? convertPackagePriceToAreaPrice(props.activeVariant.priceInfo.price) : convertPackagePriceToAreaPrice(props.activeVariant.priceInfo.priceBeforeVat);
  }
  return null;
});

const taxLabel = computed(() => {
  if (globalContent.getCountryCode !== 'fr') return '';
  return globalContent.getIsB2b ? 'HT' : 'TTC';
});

</script>
